const normalizarChave = (valor) => {
  if (!valor || typeof valor !== 'string') return '';
  return valor
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
};

/** Usuário do setor de contratos (visão global + filtro multi-setor). */
export function isUsuarioSetorContratos({ user, isAdmin, isFiscal }) {
  if (isAdmin) return true;
  const setorCodigo = normalizarChave(user?.setor || '');
  const tipoCodigo = normalizarChave(user?.tipo || user?.role || '');
  if (setorCodigo.includes('CONTRAT') || setorCodigo === 'SETOR_CONTRATOS' || setorCodigo === 'SETOR_DE_CONTRATOS') {
    return true;
  }
  if (tipoCodigo.includes('CONTRAT')) return true;
  if (isFiscal) return false;
  return false;
}

/** Fiscal operacional — dados restritos ao setor do fiscal (não inclui monitor financeiro). */
export function isUsuarioFiscalRestrito({ isFiscal, isSetorContratos, rbacRole, isCoordenadorFinanceiro, isAnalistaFinanceiro }) {
  if (isCoordenadorFinanceiro || isAnalistaFinanceiro) return false;
  if (
    rbacRole === 'FISCAL_MONITOR' ||
    rbacRole === 'FINANCEIRO_ANALISTA' ||
    rbacRole === 'FINANCEIRO' ||
    rbacRole === 'LOCAL_ADMIN' ||
    rbacRole === 'LOCAL_OPERATOR'
  ) {
    return false;
  }
  return Boolean(isFiscal && !isSetorContratos);
}

/**
 * Monta query string para APIs do dashboard de contratos.
 * @param {{ unidade?: string, setoresSelecionados?: string[], setorLogado?: string, ano?: number }} opts
 */
export function buildContratosDashboardQuery(opts = {}) {
  const params = new URLSearchParams();
  if (opts.unidade) params.set('unidade', opts.unidade);
  if (opts.ano) params.set('ano', String(opts.ano));
  if (opts.setorLogado) {
    params.set('setorLogado', opts.setorLogado);
  } else if (opts.setoresSelecionados?.length) {
    params.set('setoresSelecionados', JSON.stringify(opts.setoresSelecionados));
  }
  return params.toString();
}

export { normalizarChave };
